import React, {useEffect, useRef, useState} from 'react';
import {sendData} from "../../../store/actions";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import useSocket from "../../common/useSocket";
import UInput from "ubs-framework/v2/UInput";
import * as Icon from "ubs-icons"
import AppHeader from "../../common/components/app-header";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import {withRouter} from "../../../common/hocs/routing-hoc";
import LayoutV2 from '../../../components/layout-v2';
import { COLOR } from 'ubs-framework/v2/common/constant';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function ForgotPassword(props) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [email, setEmail] = useState("")

    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));
    const {on, off, refresh} = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'forgotPassword':
                    history.push(props?.projectRoutes?.email || '/email-sent')
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const onSubmit = data => {
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            sendData(dispatch, 'forgotPassword', {email});
        } else {
            validator?.current?.showMessages()
        }

    }
    useEffect(() => {
        on()
        return () => off();
    }, [])

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmit(e)
        }
    }

    return (
        <React.Fragment>
            <LayoutV2 module="forgot">
                <div className="u_p-24">

                    <div className="u_flex u_content-center u_mb-16">
                        <div className="u_border-radius-8 u_b-light u_p-12">
                            <Icon.Key size={24} fill={COLOR.u_icon_bg} />
                        </div>
                    </div>

                    <div className="u_text-center u_mb-24">
                        <h3 className="u_title u_text-bold u_mt-16 u_mb-12">Forgot your password?</h3>
                        <p className="u_small-font">No worries, we’ll send you reset instructions.</p>
                    </div>

                    <UInput
                        className={`u_mb-16`}
                        label="Email Address"
                        asterisk
                        hasError={validator?.current?.message("email", email, "required|email")}
                        testId={TEST_ID.FORGOT_PASSWORD.INPUT_WRAPPER}>
                        <input
                            onKeyUp={onKeyUp}
                            type="text"
                            value={email}
                            name="email"
                            onChange={(e) => {
                                setEmail(e.target.value = e.target.value.replace(/^\s+/g, ''))
                            }}
                            placeholder=" "
                            data-testid={TEST_ID.FORGOT_PASSWORD.EMAIL_INPUT} />
                    </UInput>
                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_forgotpass u_mt-10" style={{marginBottom: '10px'}}>
                        <span onClick={() => history.push(props?.projectRoutes?.forgetWithRecovery || "/forget-with-recovery")}  className="u_forgotpass__link u_cp">Try Recovery code?</span>
                    </div>
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.FORGOT_PASSWORD.SUBMIT_BUTTON}>Submit
                        </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                </div>
            </LayoutV2>
        </React.Fragment>
    );
}


export default withRouter(ForgotPassword);

